import { bindEvents, mq, multiAddEventListener, multiRemoveEventListener } from '../../../assets/js/helpers';

const selector = 'navigation-mobile';

export default class NavigationMobile {

	constructor() {
		const section = document.querySelector(`.${selector}`);

		this.el = {
			section,
			hamburger: section.querySelector(`.${selector}__hamburger`),
			navigation: section.querySelector(`.${selector}__expanded`),

			// buttons
			logo: section.querySelector(`.${selector}__logo`),
			navItemsPrimary: section.querySelectorAll(`.${selector}__expanded-primary a`),
			navItemsSecondary: section.querySelectorAll(`.${selector}__expanded-secondary a`)
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// class variable groups
		this.config = {
			closeDelay: 120
		};

		this.flags = {
			isEnabled: false
		};

		// class variable singles

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		if (mq('medium')) {
			this.disable();
		} else {
			this.enable();

			this.el.hamburger.addEventListener('click', this.events._onHamburgerClick);
			this.el.logo.addEventListener('click', this.events._onLogoClick);

			multiAddEventListener(this.el.navItemsPrimary, 'click', this.events._onNavItemPrimaryClick);
			multiAddEventListener(this.el.navItemsSecondary, 'click', this.events._onNavItemSecondaryClick);
		}
	}

	removeEventListeners() {
		this.el.hamburger.removeEventListener('click', this.events._onHamburgerClick);
		this.el.logo.removeEventListener('click', this.events._onLogoClick);

		multiRemoveEventListener(this.el.navItemsPrimary, 'click', this.events._onNavItemPrimaryClick);
		multiRemoveEventListener(this.el.navItemsSecondary, 'click', this.events._onNavItemSecondaryClick);
	}

	// listener methods

	_onHamburgerClick(e) {
		e.preventDefault();
		this.toggle();
	}

	_onLogoClick() {
		this.collapse(true);
	}

	_onNavItemPrimaryClick() {
		this.collapse(true);
	}

	_onNavItemSecondaryClick() {
		this.collapse(true);
	}

	// nav methods

	toggle() {
		if (!this.el.section.classList.contains('is-expanded')) {
			this.expand();
		} else {
			this.collapse();
		}
	}

	expand() {
		this.el.section.classList.add('is-expanded');
		this.el.hamburger.classList.add('is-active');
	}

	collapse(delayed = false) {
		const delay = delayed ? this.config.closeDelay : 0;
		setTimeout(() => {
			this.el.section.classList.remove('is-expanded');
			this.el.hamburger.classList.remove('is-active');
		}, delay);
	}

	// enable / disable

	enable() {
		if (!this.isEnabled) {
			this.isEnabled = true;
		}
	}

	disable() {
		if (this.isEnabled) {
			this.isEnabled = false;
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
